"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClearIndicator = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSelect = require("react-select");
var ClearIndicator = exports.ClearIndicator = function ClearIndicator(props) {
  var selectProps = props.selectProps;
  var isClearable = selectProps.isClearable;
  return isClearable ? /*#__PURE__*/_react["default"].createElement(_reactSelect.components.ClearIndicator, props) : null;
};